import React from 'react'
import { connect } from 'react-redux'
import Stacks from '../components/Stacks/index';
import Drawer from '../components/funtComponents/DrawerLeft';


const Facturación = () => {

  

    return (
        <>
            <Drawer/>
            <Stacks/>
            
        </>
    )
}

const mapStateToProps = (store) => ({
    menu: store.userState.menu,
  
  })
  
  export default connect(mapStateToProps, null)(Facturación);
